"use strict";

/**
 * Режим сжатия группы кнопок.
 * @since 5.0.0.4104
 * @readonly
 * @enum {string} GROUP_FOLD_MODE
 * @example
 * //В группе кнопок, именуемой ATTACHMENTS, убрать подписи у маленьких кнопок.
 * WebAccess.current.toolBar.groups.ATTACHMENTS.compress(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS);
 */
var GROUP_FOLD_MODE = {
  /** Убрать подписи у маленьких кнопок */
  SHRINK_SMALL_BUTTONS: 0,
  /** Преобразовать большие кнопки в столбец из маленьких */
  CONVERT_LARGE_BUTTONS: 1,
  /** Свернуть группу, состоящую из маленьких кнопок, в одну большую кнопку */
  COLLAPSE: 2,
  /** Свернуть группу кнопок по приоритету: CONVERT_LARGE_BUTTONS > SHRINK_SMALL_BUTTONS > COLLAPSE */
  AUTO: 3
};

/**
* Группа панели инструментов.
* 
* @class WebAccess.components.wrappers.toolBar.ToolBarGroup
* @extends WebAccess.components.wrappers.BasePageElement
* @property {string} name Имя группы
* @property {string} priority Приоритет сворачивания группы
* @property {string} selector Путь в DOM-иерархии к объекту группы, например div.content#container
* @param {string} itemSelector Существующий элемент страницы
* @return {WebAccess.components.wrappers.toolBar.ToolBarGroup}
*/

(function (global) {
  var toolBarConatainerSelector = "#toolbar_container";
  var groupSelector = "div.toolbar_group";
  var separatorSelector = "div.toolbar_separator";
  var groupHeaderSelector = "div.toolbar_group_header";
  var buttonAndColumnSelector = "div.toolbar_item, div.toolbar_column";
  var smallButtonSelector = "div.small_toolbar_item";
  var jToolBarConatainer = $(toolBarConatainerSelector);
  var toolBarBottomBorderClass = 'toolbar_bottom_border';
  var buttonArrowSelector = ".toolbar-item__arrow";


  global.index = 100;

  var ToolBarGroup = global.components.wrappers.BasePageElement.extend({
    init: function (itemSelector) {
      this._super(itemSelector);
      this.selector = format(this._byNameSelectorTemplate, groupSelector, this.name);
      this._index = global.index += 1;
      this.priority = this._jObject.attr('priority');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** @private */
    priority: null,
    _isCollapsed: false,
    _index: 0,
    className: "ToolBarGroup",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создать кнопку в текущей группе.
    *
    * @method ToolBarGWebAccess.components.wrappers.toolBar.ToolBarGroup#createButton
    * @param {string} buttonName Имя создаваемой кнопки
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    createButton: function (buttonName, opt_smallSized) {
      var newButton = global.current.toolBar.buttons.create(this.name, buttonName, opt_smallSized);
      return newButton;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть группу кнопок с панели инструментов.
    * 
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#hide
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    */
    hide: function () {
      this._super();
      this.hideNextSeparator();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отобразить группу кнопок на панели инструментов.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#show
     * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    */
    show: function () {
      this._super();
      this.showNextSeparator();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
     * Установка подписи группы кнопок
     *
     * @comment Keit_B: Новый. Пока не трогаю. Ранее: Унаследован от BasePageElement.
     * @param {string} text текст подписи
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#setLabel
     * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup}
    */
    setLabel: function (text) {
      this._jObject.children(groupHeaderSelector).find("span").text(text);
      this.fire("change");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
     * Получение текста подписи группы
     * 
     * @comment Keit_B: Новый. Пока не трогаю. Ранее: Унаследован от BasePageElement.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#getLabel
     * @return {string}
    */
    getLabel: function () {
      return this._jObject.children(groupHeaderSelector).find("span").text();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**    
    * Сворачивание группы кнопок     
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#collapse
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup}
    */
    collapse: function () {
      if (!this.isCollapsed()) {

        var me = this;
        var headerInlineBlock = 'inline-block';
        var addedGroupSelector = "div[id^='addedDiv']";

        jToolBarConatainer.find(addedGroupSelector + ":visible").hide();
        var items = this._jObject.children(buttonAndColumnSelector).filter(':visible');
        var jButtonArrows = items.find(buttonArrowSelector);
        var smallItems = items.find(smallButtonSelector);
        //Нельзя сворачивать группы из одной кнопки. А также нельзя скрывать группы с кнопками со стрелками, чтобы не получилось многоуровневое меню.
        if (items.length + smallItems.length > 1 && jButtonArrows.length === 0) {
          var tbgroup_header = this._jObject.children(groupHeaderSelector);
          tbgroup_header.css('display', headerInlineBlock).unbind('click').bind('click', function (evt) {
            evt.stopPropagation();
            var elem = $(this).nextAll(addedGroupSelector);
            if (elem.css('display') != 'none') {
              elem.hide();
            } else {
              var docWidth = $(document).width();
              $(addedGroupSelector).hide();
              elem.show();
              var jHiddenDiv = me._jObject.find(".addedHiddenDiv:visible").css("left", "");
              var divWidth = jHiddenDiv.width();
              if (divWidth > (docWidth - jHiddenDiv.position().left)) jHiddenDiv.css("left", docWidth - divWidth);
            };
          });

          tbgroup_header.nextAll(buttonAndColumnSelector).hover(function () { $(this).addClass("hover"); }, function () { $(this).removeClass("hover"); });

          this._jObject.append(format(CT.toolBar.groupCollapsed, this._index, this._jObject.css('left')));

          var jAddedDiv = $("#addedDiv" + this._index);
          items.appendTo(jAddedDiv);
          fixSvg(jAddedDiv[0]);

          this._isCollapsed = true;
          this.fire("collapse");
        } else {
          return this;
        }

        this._autoHideGroup($(".addedHiddenDiv"));
        items.hover(function () { $(this).addClass("hover"); }, function () { $(this).removeClass("hover"); });
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
    * Автоскрытие группы, когда мышь находится вне её.
    *
    * @private 
    * @since 5.0.0.4212
    */
    _autoHideGroup: function (jGroup) {
      var rebind = function (jObject) {
        jObject.unbind('click.collapse').bind('click.collapse', function () {
          jGroup.hide();
        });
      };

      setTimeout(function () {
        var frameDocument = $('iframe').contents().get(0);
        var jFrame = $(frameDocument);
        rebind(jFrame);
      }, 1000);

      rebind($('body'));

      var autohide;
      jGroup
        .off('mouseenter.collapse').off('mouseleave.collapse')
        .on('mouseenter.collapse', function () { if (autohide) clearTimeout(autohide); })
        .on('mouseleave.collapse', function () {
          autohide = setTimeout(
               function () {
                 jGroup.hide();
               }, 500);
        });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
    * Сжать маленькие кнопки до размера иконок.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#_shrinkSmallButtons
    * @private
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup}    
    */
    _shrinkSmallButtons: function () {
      var jColumn = this._jObject.find("div.toolbar_column").not(".shrinked").last();
      if (jColumn.length > 0) {
        var canBeShrinked = true;
        jColumn.find(smallButtonSelector + " div p").each(function (i, item) {
          if ($(this).width() == 0) return canBeShrinked = false;
        });

        jColumn.addClass("shrinked");
        if (!canBeShrinked) jColumn.addClass("no_icon");

      };

      jColumn = this._jObject.find("div.toolbar_column").not(".shrinked").last();
      if (jColumn.length == 0) return false;
      else return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
    * Пошаговое сжатие группы кнопок, по приоритетам операций. При сворачивании в группу, восстанавливаем все кнопки в первоначальное состояние.
    * @private
    */
    _autoCompress: function () {
      if (this._jObject.children(".toolbar_item").not(".packed").length > 0) { this.fold(GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS); return true; };
      if (this._jObject.children(".toolbar_column").not(".shrinked").length > 0) { this.fold(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS); return true; };
      if (!this.isCollapsed()) {
        while (this._jObject.children(".toolbar_column.shrinked").length > 0) { this.unfold(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS); };
        while (this._jObject.find(".toolbar_button.packed").length > 0) { this.unfold(GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS); };
        this.fold(GROUP_FOLD_MODE.COLLAPSE);
        return false;
      };
      return false;
    },

    _autoRestore: function () {
      if (this.isCollapsed()) {
        this.unfold(GROUP_FOLD_MODE.COLLAPSE);
        while (this._jObject.children(".toolbar_item").not(".packed").length > 0) { this.fold(GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS); };
        while (this._jObject.children(".toolbar_column").not(".shrinked").length > 0) { this.fold(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS); };
        return true;
      };
      if (this._jObject.children(".toolbar_column.shrinked").length > 0) { this.unfold(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS); return true };
      if (this._jObject.find(".toolbar_button.packed").length > 0) { this.unfold(GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS); return true };
      return false;
    },

    /**
    * Восстановление текста маленьких кнопок которые были свернуты в икноку.
    * @private
    */
    _restoreSmallButtons: function () {
      var jColumn = this._jObject.find("div.toolbar_column.shrinked").last();
      if (jColumn.length > 0) {
        jColumn.removeClass("shrinked");
      } else return false;

      jColumn = this._jObject.find("div.toolbar_column.shrinked").last();
      if (jColumn.length == 0) return false;
      else return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * В группе ищем все большие группы без класса .packed
    * @private
    */
    _convertLargeButtons: function () {
      var jLargeButtons = this._jObject.find('div.toolbar_item').not('.packed');
      if (jLargeButtons.length == 0) return false;
      var buttons = this.getButtons();

      var i;
      var count = i = (jLargeButtons.length < 3 ? jLargeButtons.length - 1 : 2);
      for (i = 0; i <= count; i++) {
        var jButton = $(jLargeButtons[jLargeButtons.length - i - 1]);
        var buttonName = jButton.attr('name');
        if (buttons.hasOwnProperty(buttonName)) {
          if (typeof buttons[buttonName] !== 'undefined')
            buttons[buttonName].convertTo(BUTTON.SMALL);
        }
        jButton.addClass('packed');
        if (jButton.prev().is(".toolbar_column")) break;
      };

      jLargeButtons = this._jObject.find('.toolbar_item').not('.packed');
      if (jLargeButtons.length == 0) return false;
      else return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @private
    */
    _convertSmallButtons: function () {
      var jSmallButtons = this._jObject.find('div.toolbar_button.packed');
      var buttons = this.getButtons();

      var i;
      var count = i = (jSmallButtons.length < 3 ? jSmallButtons.length - 1 : 2);
      for (i; i > -1; i--) {

        var jButton = $(jSmallButtons[count - i]);
        var btnByName = buttons[jButton.attr('name')];
        if (typeof btnByName !== 'undefined')
          btnByName.convertTo(BUTTON.LARGE);
        jButton.removeClass('packed');
        //if (jButton.next().is(".toolbar_column")) break;
      };

      jSmallButtons = this._jObject.find('.small_toolbar_item.packed');
      if (jSmallButtons.length == 0) return false;
      else return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Пошагово сжать группу кнопок.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#fold
    * @param {GROUP_FOLD_MODE} foldMode Режим сжатия
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    * @since 5.0.0.4104
    */
    fold: function (foldMode) {
      switch (foldMode) {
        case GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS:
          return this._shrinkSmallButtons();
          break;
        case GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS:
          return this._convertLargeButtons();
          break;
        case GROUP_FOLD_MODE.COLLAPSE:
          this.collapse();
          return false;
          break;
        case GROUP_FOLD_MODE.AUTO:
          return this._autoCompress();
          break
        default:
          return this._autoCompress();
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
    * Пошагово восстановить группы кнопок.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#unfold
    * @param {GROUP_FOLD_MODE} foldMode Режим сжатия
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    * @since 5.0.0.4104
    */
    unfold: function (foldMode) {
      switch (foldMode) {
        case GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS:
          return this._restoreSmallButtons();
          break;
        case GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS:
          return this._convertSmallButtons();
          break;
        case GROUP_FOLD_MODE.COLLAPSE:
          this.expand();
          return false;
          break;
        case GROUP_FOLD_MODE.AUTO:
          return this._autoRestore();
          break;
        default:
          return this._autoRestore();
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сжать группу в указанный размер.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#fitToWidth
    * @param {integer} width Ширина, в которую необходимо вписать группу.
    * @return {boolean} Результат сжатия. True – группы вместилась, иначе False.
    * @since 5.0.0.4104
    */
    fitToWidth: function (width) {
      if (this.getWidth() > width) {
        var stop = true;
        while (stop && this.getWidth() > width) {
          stop = this.fold(GROUP_FOLD_MODE.CONVERT_LARGE_BUTTONS);
        };

        stop = true;
        while (stop && this.getWidth() > width) {
          stop = this.fold(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS);
        };
        if (this.getWidth() > width) this.fold(GROUP_FOLD_MODE.COLLAPSE);
        return this.getWidth() > width;
      };
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Развернуть кнопки группы.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#expand
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    */
    expand: function () {
      if (this.isCollapsed()) {
        var jAddedDiv = this._jObject.find('#addedDiv' + this._index);
        var items = jAddedDiv.children(buttonAndColumnSelector);
        items.appendTo(this._jObject);
        fixSvg(this._jObject[0]);
        jAddedDiv.remove(); //удалять надо после вставки в другое место иначе теряются обработчики событий.

        this._jObject.children('.toolbar_group_header').css('display', 'none');

        setRealHeightAndWidth();
        var jSmallItems = items.find('.small_toolbar_item');
        items.add(jSmallItems).hover(function () {
          if (!$(this).hasClass('disabled')) {
            $(this).addClass('hover');
          };
        }, function () {
          if (!$(this).hasClass('disabled')) {
            $(this).removeClass('hover');
          };
        });
        this._isCollapsed = false;
        this.fire('expand');
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак свернутой группы.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#isCollapsed
     * @return {boolean} True, если группа свернута, иначе False.
    */
    isCollapsed: function () {
      return this._isCollapsed; //this._jObject.children(groupHeaderSelector).is(":visible");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить ширину группы.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#getWidth
     * @return {integer} Ширина группы.
     * @since 5.0.0.4104
    */
    getWidth: function () {
      return this._jObject.width();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Имитировать щелчок мыши на кнопке свернутой группы.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#click
    * @throws ERR_CANT_CLICK_ON_EXPANDED_GROUP – метод click поддерживается только для свернутых групп.
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    */
    click: function (opt_callback) {
      var jHeader = this._jObject.children(groupHeaderSelector);

      if (this.isCollapsed()) {
        if ($.isFunction(opt_callback)) {
          this._disableClickHandler(jHeader);
          this.bind("click", opt_callback);
          this.jHeader.bind("click", function () { instance.fire("click"); });
        } else jHeader.click();
      } else global.raise("ERR_CANT_CLICK_ON_EXPANDED_GROUP");
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить список кнопок текущей группы.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#getButtons
    * @return {WebAccess.current.toolBar.buttons} Список объектов типа ToolBarButton, вложенных в эту группу.
    */
    getButtons: function () {
      var me = this;
      var buttons = global.current.toolBar.buttons.toArray();
      var filteredButtons = {};
      var filtered = _(buttons).filter(function (button) {
        return button.groupName === me.name;
      });
      for (var buttonName in filtered) {
        filteredButtons[filtered[buttonName].name] = filtered[buttonName];
      };
      return new WA.Collection(filteredButtons);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

    /**
    * Добавить нижнюю границу к текущей группе.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#addBottomBorder
    * @param {string} color CSS-класс цвета нижней границы
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    * @since 5.0.0.4200
    */
    addBottomBorder: function (color) {
      var me = this;
      var jBottomBorder = me._jObject.children('.' + toolBarBottomBorderClass)
      if (jBottomBorder.length == 0) {
        // Дополнительный div нужен что бы сделать ему position:relative, 
        // т.к. у toolbar_group этого сделать нельзя, потому что ломается выпадающий список сгруппированных кнопок.
        // А вообще position:relative нужен что бы в IE7 нормально заработало.
        jBottomBorder = $('<div><div></div></div>');
        me._jObject.prepend(jBottomBorder);
      }
      jBottomBorder.removeClass().addClass(toolBarBottomBorderClass + ' ' + color);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

    /**
    * Скрыть следующий за группой разделитель.
    * 
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#hideNextSeparator
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    * @since 5.0.0.4212
    */
    hideNextSeparator: function () {
      this._jObject.next(separatorSelector).hide();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

    /**
    * Показать следующий за группой разделитель.
    * 
    * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#showNextSeparator
    * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
    * @since 5.0.0.4212
    */
    showNextSeparator: function () {
      this._jObject.next(separatorSelector).show();
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   
  });

  global.components.wrappers.toolBar.ToolBarGroup = ToolBarGroup;
})(window.WebAccess);